/**
 * R4.5 per-store theme. Spread the result on the element that wraps ONE
 * store's content (product page main area) -- never on global chrome.
 * Presets and the accent rules come from src/theme/tokens.css
 * ([data-store-theme="..."], [data-store-accent], generated by
 * scripts/gen-theme-tokens.js). A custom accent (admin-validated: white text
 * >= 4.5:1) recolours the CTA in both modes and primary/store-ink in light.
 * Keep in sync with storefront/lib/storeTheme.ts.
 */
export const THEME_PRESETS = ['zaynic', 'ocean', 'emerald', 'maroon', 'charcoal', 'royal'];

const HEX_RE = /^#[0-9a-fA-F]{6}$/;

function hexToRgb(hex) {
  const n = parseInt(hex.slice(1), 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}

const toVar = (rgb) => rgb.map((c) => Math.max(0, Math.min(255, Math.round(c)))).join(' ');

export function storeThemeProps(preset, accent) {
  const props = {};
  if (preset && preset !== 'zaynic' && THEME_PRESETS.includes(preset)) {
    props['data-store-theme'] = preset;
  }
  if (accent && HEX_RE.test(accent)) {
    const rgb = hexToRgb(accent);
    props['data-store-accent'] = '';
    props.style = {
      '--store-accent': toVar(rgb),
      '--store-accent-hover': toVar(rgb.map((c) => c * 0.85)),
      '--store-accent-light': toVar(rgb.map((c) => c + (255 - c) * 0.55)),
    };
  }
  return props;
}

/** WCAG contrast ratio of a hex colour against white (same formula as the backend). */
export function contrastWithWhite(hex) {
  if (!HEX_RE.test(hex || '')) return 0;
  const lum = hexToRgb(hex)
    .map((c) => c / 255)
    .map((c) => (c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4));
  const l = 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
  return 1.05 / (l + 0.05);
}
